/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowBarbecuePartyTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowBarbecueParty,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Grill and Chill!",
    "BBQ Bash Awaits!",
    "Sizzle and Serve!",
  ],
  title: "Barbecue Party",
  description: "Organize a fun barbecue party.",
  longDescription:
    "Gather your friends for a delicious barbecue party! Choose a date, plan the menu, and decide on activities for a fun-filled day!",
  emoji: "🍖",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Barbecue Party",
          emoji: "🍖",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the barbecue party?",
          emoji: "📅",
          completeAction: {
            question: "Decide on the menu?",
            description: "What should we grill for the barbecue?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What menu items should we include?",
                emoji: "🍔",
                completeAction: {
                  question: "Decide on drinks?",
                  description: "What drinks should we serve at the barbecue?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What drinks should we bring?",
                      emoji: "🍹",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Get Ready to Grill!",
    outroDescription:
      "Your barbecue party plans are set! Enjoy good food and company!",
  },
};
